export * from "@genstackio/react-context-api/lib/hooks/useLazyQueryApi";
export {default as default} from "@genstackio/react-context-api/lib/hooks/useLazyQueryApi";
